import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _toConsumableArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import Base from "./Base";
import DPServices from "@dp/services";
import { observable, runInAction, computed, makeObservable, action } from "mobx";
var Messages = (_class = /*#__PURE__*/function (_Base) {
  _inherits(Messages, _Base);

  var _super = _createSuper(Messages);

  function Messages(rootStore) {
    var _this;

    _classCallCheck(this, Messages);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "_rootStore", void 0);

    _initializerDefineProperty(_assertThisInitialized(_this), "_showErrorDialog", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_showSuccessDialog", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_options", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_title", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_subTitles", _descriptor5, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_additionalMessages", _descriptor6, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_showDateTimeSelection", _descriptor7, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_showLeadTimeRadioSelection", _descriptor8, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_suppressErrorDialog", _descriptor9, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_dialogueCode", _descriptor10, _assertThisInitialized(_this));

    _this._rootStore = rootStore;
    _this._showErrorDialog = false;
    _this._showSuccessDialog = false;
    makeObservable(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Messages, [{
    key: "setupReactions",
    value: function setupReactions() {
      return;
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "showError",
    value: function showError(title, message, additionalMessages, options) {
      var showDateTimeSelection = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var showLeadTimeRadioSelection = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      var dialogueCode = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
      this._title = title;
      this._subTitles = [message];
      this._additionalMessages = additionalMessages;
      this._showErrorDialog = true;
      this._options = options;
      this._showDateTimeSelection = showDateTimeSelection;
      this._showLeadTimeRadioSelection = showLeadTimeRadioSelection;
      this._dialogueCode = dialogueCode;
    }
  }, {
    key: "showSuccess",
    value: function showSuccess(title, message, additionalMessages, options) {
      var _this2 = this;

      var dialogueCode = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      this._title = title;
      this._subTitles = [message];
      this._additionalMessages = additionalMessages;
      this._showSuccessDialog = true;
      this._options = options;
      runInAction(function () {
        _this2._dialogueCode = dialogueCode;
      });
    }
  }, {
    key: "isEmpty",
    value: function isEmpty(val) {
      return val && val.length > 0;
    }
  }, {
    key: "showErrorMessage",
    value: function showErrorMessage(title, errorObj, options) {
      var _this3 = this;

      var dialogueCode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var parsed = DPServices.Cart.parseErrors(errorObj);
      var faults = parsed === null || parsed === void 0 ? void 0 : parsed.faults;
      var unAvailableItems = parsed === null || parsed === void 0 ? void 0 : parsed.unAvailableItems;
      this._title = title;

      if (faults && faults.length > 0) {
        this._subTitles = faults.reduce(function (prev, fault) {
          prev = [].concat(_toConsumableArray(prev), _toConsumableArray(fault.faultDescription.split("|")));
          return prev;
        }, []);
      }

      if (unAvailableItems && unAvailableItems.length > 0) {
        this._additionalMessages = unAvailableItems.map(function (item) {
          return item.displayName;
        });
      }

      if (options) {
        this._options = options;
      }

      runInAction(function () {
        _this3._dialogueCode = dialogueCode;
      });
      this.showErrorDialog = true;
    }
  }, {
    key: "showDateTimeSelection",
    get: function get() {
      return !!this._showDateTimeSelection;
    }
  }, {
    key: "showLeadTimeRadioSelection",
    get: function get() {
      return !!this._showLeadTimeRadioSelection;
    }
  }, {
    key: "showErrorDialog",
    get: function get() {
      return this._suppressErrorDialog ? false : this._showErrorDialog;
    },
    set: function set(showErrorDialog) {
      var _this4 = this;

      runInAction(function () {
        _this4._showErrorDialog = showErrorDialog;
        if (!showErrorDialog) _this4._options = null;
      });
    }
  }, {
    key: "supressErrorDialog",
    get: function get() {
      return this._suppressErrorDialog;
    },
    set: function set(val) {
      var _this5 = this;

      runInAction(function () {
        _this5._suppressErrorDialog = val;
      });
    }
  }, {
    key: "showSuccessDialog",
    get: function get() {
      return this._showSuccessDialog;
    },
    set: function set(showSuccessDialog) {
      var _this6 = this;

      runInAction(function () {
        _this6._showSuccessDialog = showSuccessDialog;
        if (!showSuccessDialog) _this6._options = null;
      });
    }
  }, {
    key: "dialogOptions",
    get: function get() {
      return this._options;
    }
  }, {
    key: "customButtonsConfigured",
    get: function get() {
      return this._options && (this.isEmpty(this._options.okBtnText) || this.isEmpty(this._options.cancelBtnText));
    }
  }, {
    key: "additionalMessages",
    get: function get() {
      return this._additionalMessages;
    }
  }, {
    key: "title",
    get: function get() {
      return this._title;
    }
  }, {
    key: "subTitles",
    get: function get() {
      return this._subTitles;
    }
  }, {
    key: "dialogueCode",
    get: function get() {
      return this._dialogueCode;
    }
  }]);

  return Messages;
}(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_showErrorDialog", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_showSuccessDialog", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_options", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_title", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_subTitles", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_additionalMessages", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_showDateTimeSelection", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_showLeadTimeRadioSelection", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_suppressErrorDialog", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_dialogueCode", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "showDateTimeSelection", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showDateTimeSelection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showLeadTimeRadioSelection", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showLeadTimeRadioSelection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showError", [action], Object.getOwnPropertyDescriptor(_class.prototype, "showError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showSuccess", [action], Object.getOwnPropertyDescriptor(_class.prototype, "showSuccess"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showErrorDialog", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showErrorDialog"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "supressErrorDialog", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "supressErrorDialog"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showSuccessDialog", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showSuccessDialog"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dialogOptions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "dialogOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "customButtonsConfigured", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "customButtonsConfigured"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "additionalMessages", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "additionalMessages"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "title", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "title"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "subTitles", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "subTitles"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showErrorMessage", [action], Object.getOwnPropertyDescriptor(_class.prototype, "showErrorMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dialogueCode", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "dialogueCode"), _class.prototype)), _class);
export { Messages as default };